import React from 'react'
import styles from './LPHeader.module.scss'
import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

interface HeaderLink {
  href: string
  title: string
}

const headerLinks: HeaderLink[] = [
  {
    href: '#OurAdvantage',
    title: 'Aitriaの強み',
  },
  {
    href: '#Process',
    title: 'プロセス',
  },
  {
    href: '#OurWorks',
    title: '実績',
  },
  {
    href: '#CaseStudy',
    title: 'ケーススタディ',
  },
  {
    href: '#FAQ',
    title: 'よくある質問',
  },
]

const LPHeader: React.FC = () => {
  const header = useRef<HTMLDivElement>()

  useEffect(() => {
    if (window.matchMedia('(max-width: 1024px)').matches) {
      gsap.from(header.current, {
        duration: 0.3,
        opacity: 0,
        scrollTrigger: {
          trigger: '.LpIntroduction_h2__bD0HU',
          start: 'top top+=10%',
          toggleActions: 'play none none reverse',
        },
      })
    }
    if (process.browser) {
      const header = document.getElementById('ul')
      window.addEventListener('scroll', function () {
        if (window.scrollY > 20) {
          header.style.transform = 'scale(0.9)'
          header.style.marginTop = '40px'
        } else {
          header.style.transform = 'scale(1)'
          header.style.marginTop = '60px'
        }
      })
    }
  }, [])

  const headerList = headerLinks.map(({ href, title }) => (
    <li className={`${styles.li} ${styles.SP_none}`} key={href}>
      <a href={href}>{title}</a>
    </li>
  ))

  return (
    <header>
      <div ref={header}>
        <ul className={styles.ul} id="ul">
          <li className={styles.i3_img_li}>
            <a href="#Top">
              <img className={styles.i3_img} src="/img/common/logo_aitria.svg" alt="Aitria" />
            </a>
          </li>
          {headerList}
          <li className={styles.li}>
            <a className={styles.contact} href="#Contact">
              お問い合わせ
            </a>
            <span className={styles.mailIcon}></span>
          </li>
        </ul>
      </div>
    </header>
  )
}

export default LPHeader
